import Color from 'color';
import styled from 'styled-components';

import { AnimatedBorder } from '@hivebrite/design-system/AnimatedBorder';
import { Box, type BoxProps } from '@hivebrite/design-system/Box';

import { useOnlyOncePerSession } from './hooks/useOnlyOncePerSession';

interface AIWrapperProps extends BoxProps {
  children: React.ReactNode;
  id: string;
  shouldTriggerOnlyOncePerSession?: boolean;
  style?: React.CSSProperties;
  trigger: boolean;
}

export const AIWrapper = ({
  id,
  children,
  trigger = false,
  shouldTriggerOnlyOncePerSession = false,
  ...otherProps
}: AIWrapperProps) => {
  const { hasBeenSeen } = useOnlyOncePerSession({
    id,
    enabled: trigger && shouldTriggerOnlyOncePerSession,
  });

  const shouldTrigger = shouldTriggerOnlyOncePerSession
    ? trigger && !hasBeenSeen
    : trigger;

  return (
    <AnimatedBorder trigger={shouldTrigger}>
      <StyledWrapper {...otherProps}>{children}</StyledWrapper>
    </AnimatedBorder>
  );
};

const StyledWrapper = styled(Box).attrs(({ theme }) => ({
  backgroundColor: Color(theme.colors.horizon).alpha(0.15).rgb().string(),
  p: 4,
}))`
  border-radius: ${({ theme }) =>
    `${theme.themeVariables.globalBorderRadius}px`};
`;
